module.exports = __webpack_public_path__ + "img/monday-logo.8d85e49f.png";